module.exports = __webpack_public_path__ + "static/pack.6888f71a.svg";